import { useMemo } from "react";

import { generatePath, Redirect, useParams } from "react-router-dom";

import { useAlert } from "@/contexts/AlertContext";
import { useOrganization } from "@/hooks/useOrganization";
import { ROUTES } from "@/routes_new";
import { OrganizationStatus } from "@/types/Organization";

export const MentionsRedirectView = () => {
  const { orgUuid } = useParams<{ orgUuid: string }>();
  const { data: orgData } = useOrganization();
  const orgStatus = orgData?.ok ? orgData.data.status : null;
  const { alerts, groupedAlerts } = useAlert();

  const redirectTarget = useMemo(() => {
    if (!orgUuid || !alerts) return undefined;

    const firstActive = groupedAlerts.active[0];
    if (firstActive) {
      return generatePath(ROUTES.MENTION_DETAIL_ORGID, {
        orgUuid,
        uuid: firstActive.uuid,
      });
    }

    // orgStatus only needed from here — wait for it before choosing fallback
    if (!orgStatus) return undefined;

    // For expired automatic trial orgs, fall back to inactive searches
    if (orgStatus === OrganizationStatus.AutomaticTrialExpired) {
      const firstInactive = groupedAlerts.inactive[0];
      if (firstInactive) {
        return generatePath(ROUTES.MENTION_DETAIL_ORGID, {
          orgUuid,
          uuid: firstInactive.uuid,
        });
      }
    }

    return generatePath(ROUTES.SEARCH_ORGID, { orgUuid });
  }, [orgUuid, orgStatus, alerts, groupedAlerts]);

  if (redirectTarget && orgUuid) {
    return <Redirect to={redirectTarget} />;
  }

  return null;
};
